export default function HeroSection() {
  return (
    <section className="relative min-h-[calc(100vh-4rem)] flex items-center pt-16 overflow-hidden">
      {/* Full-screen background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20editorial%20fashion%20product%20flatlay%20photography%20showcasing%20luxury%20sneakers%20hoodies%20jackets%20bags%20caps%20and%20accessories%20arranged%20artistically%20on%20a%20warm%20sandy%20beige%20textured%20surface%2C%20soft%20golden%20hour%20natural%20lighting%20with%20gentle%20shadows%2C%20high-end%20European%20catalog%20aesthetic%20with%20organic%20spacing%20and%20rich%20fabric%20textures%2C%20premium%20editorial%20product%20photography%20filling%20the%20entire%20frame%20with%20beautiful%20composition&width=1920&height=1080&seq=hero-fullscreen-fashion-v4&orientation=landscape"
          alt="OOPBuy Spreadsheet Produktübersicht – Sneaker%2C Hoodies%2C Accessoires"
          title="OOPBuy Spreadsheet Produktübersicht"
          className="w-full h-full object-cover"
        />
        {/* Dark gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/50 to-foreground-950/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-10 lg:px-16 py-16 md:py-24 max-w-3xl">
        <span className="inline-block text-sm text-background-50/70 font-medium mb-4 tracking-wide uppercase border border-background-50/20 px-3 py-1 rounded-full">
          Deutschland 2026
        </span>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          OOPBuy Spreadsheet
          <br />
          <span className="italic font-semibold text-background-50/80">Deutschland – Der ultimative Einkaufsführer</span>
        </h1>
        <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-lg mb-8">
          Entdecke tausende geprüfte Produkte, vergleiche Verkäufer, spare Versandkosten und finde hochwertige Angebote – alles mit dem OOPBuy Spreadsheet.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-background-50 text-foreground-900 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Jetzt Spreadsheet öffnen
            <span className="w-6 h-6 flex items-center justify-center bg-foreground-900 text-background-50 rounded-md">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Kostenlos starten
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 mt-8 text-xs text-background-50/70">
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i> Tausende Produkte</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i> Schnelle Navigation</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i> QC Fotos</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i> Sichere Verkäufer</span>
          <span className="flex items-center gap-1"><i className="ri-check-line text-accent-400"></i> Deutschland Versand</span>
        </div>
      </div>
    </section>
  );
}